// EC-44: RFC 5321 caps an email address at 254 characters. Bounding the input
// before validation, combined with the linear (single-quantifier) pattern
// below, removes the ReDoS exposure of the previous nested-quantifier regexes.
export const MAX_EMAIL_LENGTH = 254;
export const SAFE_EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const isValidEmail = (value: string): boolean => {
  const trimmed = (value ?? '').trim();
  return trimmed.length > 0 && trimmed.length <= MAX_EMAIL_LENGTH && SAFE_EMAIL_REGEX.test(trimmed);
};

export const rules = {
  email: {
    required: true,
    validate: {
      matchPattern: (value: string) => isValidEmail(value),
    },
  },
  contactEmail: {
    required: { value: true, message: 'Please enter contact email' },
    // maxLength enforces the length cap before the pattern runs.
    maxLength: { value: MAX_EMAIL_LENGTH, message: 'Please enter email format!' },
    pattern: {
      value: SAFE_EMAIL_REGEX,
      message: 'Please enter email format!',
    },
  },
  password: {
    required: true,
    validate: { matchPattern: (value: string) => /^(?=.*[A-Z])(?=.*\d).{8,}$/.test(value.trim()) },
  },
  name: {
    required: { value: true, message: 'Please enter partner name' },
    validate: { matchPattern: (value: string) => /[\u0000-\u10FFFF]/gu.test(value.trim()) },
  },
  fullName: {
    required: { value: true, message: 'Please enter partner name' },
    pattern: {
      value: /^[a-zA-Z0-9\s!"#$%&'()*+,-./:;<=>?@[\\\]^_`{|}~\u00C0-\u017F]+$/,
      message: 'Please enter valid name format!',
    },
  },
  region: {
    required: { value: true, message: 'Please enter region name' },
    pattern: {
      value: /^[a-zA-Z0-9\s!"#$%&'()*+,-./:;<=>?@[\\\]^_`{|}~\u00C0-\u017F]+$/,
      message: 'Please enter valid name format!',
    },
  },
  zip: {
    required: true,
    validate: { matchPattern: (value: string) => /^\d{5}$/.test(value.trim()) },
  },
  shortName: {
    required: { value: true, message: 'Please enter short name' },
    validate: {
      notOnlySpaces: (value: string) => value.trim().length !== 0 || 'Please enter a valid short name',
    },
  },
};
